"use strict";
export const aboutUsGallery = () => ({
    open: false,
    init() {
        window.Fancybox.bind('[data-fancybox="quality-homes-gallery"]', {})
    }
});